import { Component, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SessionService } from 'src/app/authentication/session.service';
import { FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { contriesWithLangs } from 'src/app/seo/onboarding/languages';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import examples from '../../../../assets/phone-examples.json';
import { TargetService } from 'src/app/sidenav/target.service';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';

declare const behamics: any;

@Component({
  selector: 'app-phone-number',
  templateUrl: './phone-number.component.html',
  styleUrls: [
    '../signup-premium/signup-premium.component.css',
    '../signup/signup.component.css',
    '../login/login.component.css',
    '../../login/login.component.css',
    '../../../seo/ai-analysis/ai-analysis.component.css',
    './phone-number.component.css',
  ],
})
export class PhoneNumberComponent {
  constructor(
    private sessionService: SessionService,
    private fb: FormBuilder,
    private titleService: Title,
    private renderer: Renderer2,
    private targetList: TargetService,
    private router: Router,
    private localStorageService: LocalStorageService
  ) {
    this.titleService.setTitle('Signup - Organic');
  }

  calendlyDataURL: string = '';

  loginLoading: boolean = false;
  userInfoLoading: boolean = false;

  form = this.fb.group({
    country: ['DE', Validators.required],
    phone: ['', [Validators.required, this.validatePhoneNumber.bind(this)]],
  });

  countries = contriesWithLangs.map((obj) => {
    return {
      ...obj,
      code_lowerCase: obj?.['country']?.['code']?.toLocaleLowerCase(),
    };
  });
  filteredCountries: any = this.countries;

  placeholderValue: string = 'Enter phone number';

  showIncorrectNumberError: boolean = false;
  showApiError: boolean = false;

  public showCalendly: boolean = false;
  public isCalendlyLoading: boolean = false;
  private calendlyInitialized: boolean = false;

  isGermanVersion: boolean = true;

  showHubspot: boolean = false;
  private scriptElement!: HTMLScriptElement;

  ngOnInit() {
    document.body.classList.remove('dark-theme');

    if (location.pathname.includes('/verify-number')) {
      // this.getUserInfo();
      this.getUserIP();
      this.showHubspot = false;
    } else {
      this.injectHubspotMeeting();
      this.showHubspot = true;
    }
  }

  injectHubspotMeeting() {
    const name: string = this.localStorageService.get('name') || '';
    const email: string = this.localStorageService.get('email') || '';

    try {
      if (this.localStorageService.get('gclid_from_web')) {
        (window as any).gtag('event', 'sign_up', {
          currency: 'USD',
          gclid: this.localStorageService.get('gclid_from_web') || '',
        });
      }
    } catch (e) {
      console.log(e);
    }

    requestAnimationFrame(() => {
      const container = document.querySelector('.meetings-iframe-container');

      if (!container) return;

      let url = new URL('https://meetings.hubspot.com/valon-xhafa?embed=true');
      // let url = new URL('https://meetings.hubspot.com/patrick-fischer1');

      fetch('https://ipinfo.io/json?token=b08c09ea3c363f')
        .then((res) => {
          if (!res.ok) throw new Error('Geolocation API error: ' + res.status);
          return res.json();
        })
        .then((data) => {
          // if (data.country === 'US') {
          //   url = new URL('https://meetings.hubspot.com/valon-xhafa');
          // } else {
          //   url = new URL('https://meetings.hubspot.com/patrick-fischer1');
          // }

          url.searchParams.set('embed', 'true');
          if (name) {
            try {
              const [firstName, lastName] = name.split(' ');

              if (firstName) {
                url.searchParams.set('firstname', firstName);
              }
              if (lastName) {
                url.searchParams.set('lastname', lastName);
              }
            } catch (e) {
              url.searchParams.set('firstname', name);
              console.log(e);
            }
          }
          if (email) {
            url.searchParams.set('email', email);
          }

          container.setAttribute('data-src', url.toString());

          const script = document.createElement('script');
          script.src =
            'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
          script.type = 'text/javascript';

          document.body.appendChild(script);

          this.localStorageService.set('came_from_hbmeeting', true);

          window.addEventListener('message', (event) => {
            if (event.data && event.data.meetingBookSucceeded) {
              console.log('Meeting booked successfully!');
              this.pushAdsData();
              (window as any).gtag('event', 'conversion', {
                send_to: 'AW-11450410659/JDA-CJDxztIaEKPN_dMq',
                value: 1.0,
                currency: 'USD',
                gclid: this.localStorageService.get('gclid_from_web'),
              });
            }
          });
        })
        .catch((err) => {
          url.searchParams.set('embed', 'true');
          if (name) {
            try {
              const [firstName, lastName] = name.split(' ');

              if (firstName) {
                url.searchParams.set('firstname', firstName);
              }
              if (lastName) {
                url.searchParams.set('lastname', lastName);
              }
            } catch (e) {
              url.searchParams.set('firstname', name);
              console.log(e);
            }
          }
          if (email) {
            url.searchParams.set('email', email);
          }

          container.setAttribute('data-src', url.toString());

          const script = document.createElement('script');
          script.src =
            'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
          script.type = 'text/javascript';

          document.body.appendChild(script);

          this.localStorageService.set('came_from_hbmeeting', true);

          window.addEventListener('message', (event) => {
            if (event.data && event.data.meetingBookSucceeded) {
              console.log('Meeting booked successfully!');
              this.pushAdsData();

              (window as any).gtag('event', 'conversion', {
                send_to: 'AW-11450410659/JDA-CJDxztIaEKPN_dMq',
                value: 1.0,
                currency: 'USD',
                gclid: this.localStorageService.get('gclid_from_web'),
              });
            }
          });
        });
    });
  }

  showPassword: boolean = false;
  toogleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  signup() {
    if (this.form.valid) {
      this.showIncorrectNumberError = false;
      const selectedCountry = this.form.value.country;
      const phone = this.form.value.phone;
      const email: string = this.localStorageService.get('email') || '';

      this.sessionService
        .addPhoneNumber({
          email: email,
          phoneNumber: phone,
          country: selectedCountry,
        })
        .subscribe({
          next: (res: any) => {
            this.showApiError = false;
            try {
              (window as any).fbq('track', 'Subscribe', {
                eventID: behamics.metaEventId,
              });

              behamics._adConvertDashboard(email);
            } catch (error) {
              console.log(error);
            }

            // this.showCalendlyWidget();
            // this.injectHubspotMeeting();
            // this.showHubspot = true;

            this.router.navigate(['organic_onboarding']);

            let user = null;
            if (behamics._getCookie(behamics.variables.userStorageKey)) {
              // cookie exists
              user = JSON.parse(
                behamics._getCookie(behamics.variables.userStorageKey)
              );
            } else {
              // fallback to localStorage
              user = JSON.parse(
                localStorage.getItem(behamics.variables.userStorageKey) || '{}'
              );
            }

            const data = {
              fullname: this.localStorageService.get('name') || '',
              email: email,
              sessionID: user ? user.sessionID : 'sessionID-Not-Found',
              Product: 'Organic',
              adType: 'facebook',
              utm_source: this.localStorageService.get('utm_source') || '',
              utm_medium: this.localStorageService.get('utm_medium') || '',
              utm_campaign: this.localStorageService.get('utm_campaign') || '',
              event_type: 'all',
              gclid: this.localStorageService.get('gclid') || '',
              fbclid: this.localStorageService.get('fbclid') || '',
              phone: phone,
              seo_url: this.localStorageService.get('seo_url') || '',
              referrer: 'AI Visibility Free',
              signup: '1',
            };

            this.sessionService.adTrackerEvents(data).subscribe((res) => {});
          },
          error: (err: any) => {
            this.showApiError = true;
          },
        });
    } else {
      this.showIncorrectNumberError = true;
      this.showApiError = false;
      this.form.markAllAsTouched();
    }
  }

  showCalendlyWidget() {
    this.showCalendly = true;
    this.isCalendlyLoading = true;

    setTimeout(() => {
      if (!this.calendlyInitialized) {
        const script = this.renderer.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;

        script.onload = () => {
          this.isCalendlyLoading = false;
        };

        this.renderer.appendChild(document.body, script);
        this.calendlyInitialized = true;
      } else {
        // Re-initialize if script already loaded
        if ((window as any).Calendly) {
          (window as any).Calendly.initInlineWidgets();
          this.isCalendlyLoading = false;
        }
      }
    });
  }

  pushAdsData() {
    if (
      this.localStorageService.get('gclid_from_web') ||
      this.localStorageService.get('fbclid_from_web')
    ) {
      const data = {
        event_type: 'organic_booked', // or adcopilot_booked
        email: this.localStorageService.get('email'),
      };

      this.sessionService.pushAdsData(data).subscribe((res) => {});
    }
  }

  searchCountries(event: any) {
    const value = event?.target?.value?.toLowerCase();

    try {
      this.filteredCountries = this.countries.filter((c: any) => {
        return (
          c?.country?.name?.toLowerCase().includes(value) ||
          c?.phone?.idd?.toLowerCase().includes(value)
        );
      });
    } catch (e) {
      console.log(e);
    }
  }

  validatePhoneNumber(control: AbstractControl) {
    const country = this.form?.get('country')?.value;

    if (typeof country !== 'string') {
      return { invalidPhone: true };
    }

    const number = parsePhoneNumberFromString(
      control.value || '',
      country as any
    );
    return number && number.isValid() ? null : { invalidPhone: true };
  }

  getPhonePlaceholder(): void {
    try {
      let tmpValue = 'Enter phone number';
      const countryCode = this.form.get('country')?.value;
      const prefix = this.filteredCountries.find((c: any) => {
        return c?.country?.code == countryCode;
      }).phone.idd;

      if (countryCode) {
        const returnValue: any =
          (examples as any)?.[countryCode] || 'Enter phone number';

        tmpValue = `${prefix} ${returnValue}`;

        // if (prefix) {
        //   this.form.get('phone')?.setValue(prefix + ' ');
        // }
      }
      this.placeholderValue = tmpValue;
    } catch (error) {
      this.placeholderValue = 'Enter phone number';
    }
  }

  getUserInfo(): void {
    try {
      if (this.localStorageService.get('gclid_from_web')) {
        (window as any).gtag('event', 'sign_up', {
          currency: 'USD',
          gclid: this.localStorageService.get('gclid_from_web'),
        });
      }
    } catch (e) {
      console.log(e);
    }

    this.userInfoLoading = true;

    this.targetList
      .getCurrentUserRoles(this.localStorageService.get('email'))
      .subscribe({
        next: (data) => {
          this.userInfoLoading = false;
        },
        error: (e) => {
          this.userInfoLoading = false;
          this.router.navigate(['login']);
        },
      });
  }

  getUserIP(): void {
    this.sessionService.getUserIP().subscribe({
      next: (res) => {
        this.form.get('country')?.setValue(res?.country || 'DE');
        this.getPhonePlaceholder();
      },
      error: (e) => {
        this.getPhonePlaceholder();
        console.log(e);
      },
    });
  }

  logout() {
    this.sessionService.logout();
  }

  privatcyPolicyClick() {
    window.open('https://behamics.com/legal/privacy-policy-en.pdf', '_blank');
  }
}
